import { Component, Inject } from "@angular/core";
import { Router } from '@angular/router';

import { MatDialogRef } from "@angular/material";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: "others-failed-popup",
    template: require('./others-failed-popup.component.html'),
    styles: [require('./others-failed-popup.component.less')],
})
export class OthersFailedPopupComponent {
    constructor(
        private _router: Router,
        public othersFailedPopup: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    logout() {
        this.closePopup();
        this._router.navigate(["logout"]);
    }

    closePopup() {
        this.othersFailedPopup.close();
    }
}
